import { HttpContextToken } from '@angular/common/http';

/** Set to true on a request's HttpContext to bypass the global loader overlay. */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
